// Generated with util/create-component.js
import Landmark from './Base';

export default Landmark;
